import Plugin from '../core/Plugin';
import { PlayerEvent } from './../PlayerEvents';

/**
 * 伪直播字幕插件
 *
 * @export
 * @class LiveSubtitle
 * @extends {Plugin}
 */

export default class LiveMultiSubtitle extends Plugin {
  constructor() {
    super();
  }

  static get type() {
    return 'plugin_liveMultiSubtitle';
  }

  init(opts = {}) {
    super.init(opts);
    if (!opts.isLive) {
      return;
    }

    this._allConfig = opts;
    this._subtitleCfg = JSON.parse(opts[LiveMultiSubtitle.type]);
    this.enabled = this._subtitleCfg['live_subtitle_enable'];
    this._isLive = opts.isLive;
    this._defineMethods();
  }

  _defineMethods() {
    this.player.openLiveSubtitle = this._openLiveSubtitle.bind(this);
    this.player.closeLiveSubtitle = this._closeLiveSubtitle.bind(this);
    this.player.changeLiveSubtitle = this._changeLiveSubtitle.bind(this);
    this.player.getLiveSubtitleList = this._getLiveSubtitleList.bind(this);
  }

  // todo: 传入参数待处理
  _openLiveSubtitle(failure) {
    if (!this.enabled) {
      return;
    }
    let subtitleArr = this._getLiveSubtitleList();
    if (subtitleArr.length > 0) {
      let subtitleAlias = subtitleArr[0];
      return this._changeLiveSubtitle(subtitleAlias, failure); 
    } else{
      return failure && failure({ code: '611003', message: '未检测到实时字幕', data: {} });
    }
  }

  _closeLiveSubtitle(failure) {
    if (!this.enabled) {
      return;
    }
    return this._changeLiveSubtitle('original', failure);
  }

  _getLiveSubtitleList() {
    if (!this.enabled) {
      return [];
    }
    let mutilSubtitleMap = this.player.mutilSubtitleMap;
    if(!mutilSubtitleMap) {
      return [];
    }
    // return Object.keys(mutilSubtitleMap) || [];
    return Object.keys(mutilSubtitleMap).filter(item => {return item != "original"}) || [];
  }

  _changeLiveSubtitle(value, failure) {
    if (!this.enabled) {
      return;
    }
    // 校验参数
    let liveSubtitleList = Object.keys(this.player.mutilSubtitleMap);
    if (liveSubtitleList.indexOf(value) < 0) {
      return failure && failure({ code: '611003', message: '未检测到此类实时字幕', data: {} });;
    }

    //寻找匹配的播放地址，含CDN线路、清晰度
    let defObj = this.player.currentDefinition;
    let oldDef = defObj.def;
    let newDefObj;
    let currentLineIndex = this.player.currentDefinitionListIndex;
    let currentDefinitionArr = this.player.mutilSubtitleMap[value];
    this.player.currentSubtitleName = value;
    this.player.currentDefinitionList = currentDefinitionArr[currentLineIndex] ? currentDefinitionArr[currentLineIndex] : currentDefinitionArr[0];
    let arr = this.player.currentDefinitionList;
    for (let i = 0; i < arr.length; i++) {
      if (arr[i]['def'] === oldDef) {
        newDefObj = arr[i];
        break;
      }
    }
    if (!newDefObj) {
      newDefObj = arr[0];
    }

    // 此变量已动态监听，具体见LiveScheduler.js
    this.player.currentDefinition = newDefObj;
    if(value !== 'original') {
      this.player.player._isOpenedLiveSubtitle = true;
      this.player.emit2All(PlayerEvent.LIVESUBTITLE_OPENED);
    } else {
      this.player.player._isOpenedLiveSubtitle = false;
      this.player.emit2All(PlayerEvent.LIVESUBTITLE_CLOSED);
    }
  }

  static get type() {
    return 'plugin_liveSubtitle';
  }
}
